export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";